import kubernetes from './kubernetes.json';

import k8sClusterCpuUsage from './k8sClusterCpuUsage.json';
import k8sClusterMemoryUsage from './k8sClusterMemoryUsage.json';
import k8sCpuUsageVsRequests from './k8sCpuUsageVsRequests.json';
import k8sMemoryUsageVsLimit from './k8sMemoryUsageVsLimit.json';
import k8sPodStatusEvents from './k8sPodStatusEvents.json';
import k8sContainerMemoryUsage from './k8sContainerMemoryUsage.json';
import k8sKubernetesSummary from './k8sKubernetesSummary.json';
import k8sPodsSummary from './k8sPodsSummary.json';
import gaugeTest from './gaugeTest.json';
import k8sClusterSelector from './k8sClusterSelector.json';

export default [
  kubernetes,
  k8sClusterCpuUsage,
  k8sClusterMemoryUsage,
  k8sCpuUsageVsRequests,
  k8sContainerMemoryUsage,
  k8sMemoryUsageVsLimit,
  k8sPodStatusEvents,
  k8sPodsSummary,
  k8sKubernetesSummary,
  gaugeTest,
  k8sClusterSelector,
];
